import { Post, Get } from '../../server'

const getFaqList = async (params) => await Post('/faqs/list', { ...params })
const getFaqTypeList = async (params) => await Post('/faqType/list', { ...params })
const getAgreementList = async (params) => await Post('/agreements/list', { ...params })
const getAgreementInfo = async (params) => await Get('/agreements/info', { ...params })
const getTestCenterList = async (params) => await Post('/testCenters/list', { ...params })
const getTestCenterPage = async (params) => await Post('/testCenters/page', { ...params })
const getTestCenterInfo = async (params) => await Get('/testCenters/info', { ...params })
const getClinicDoctorList = async (params) => await Post('/testCenters/doctorList', { ...params })

const getDoctorList = async (params) => await Post(`/doctors/list`, { ...params })
const getDoctorInfo = async (params) => await Get(`/doctors/info`, { ...params })
const getNoAppointmentTimes = async (params) => await Post(`/doctors/getFullTime`, { ...params })
const getAllBookings = async (params) => await Post(`/doctors/getAllBookings`, { ...params })
const getDoctorBookings = async (params) => await Post(`/doctors/getBookingsInDoctorList`, { ...params })

const getAllTime = async (params) => await Post(`/testCenters/getAllTime`, { ...params })

const getOrderPage = async (params) => await Post(`/auth/orders/page`, { ...params })
const getOrderInfo = async (params) => await Get(`/auth/orders/info`, { ...params })
const updateOrder = async (params) => await Post(`/auth/orders/update`, { ...params })
const addOrder = async (params) => await Post(`/auth/orders/add`, { ...params })
const cancelOrder = async (params) => await Post(`/auth/orders/cancelOrder`, { ...params })

const getReportPage = async (params) => await Post(`/auth/reports/page`, { ...params })
const getReportInfo = async (params) => await Get(`/auth/reports/info/${params.id}`, { ...params })
const signIn = async (params) => await Post(`/signIn`, { ...params })
const signUp = async (params) => await Post(`/signUp`, { ...params })
const getBackPassword = async (params) => await Post(`/forgetPassword`, { ...params })
const changePassword = async (params) => await Post(`/auth/changePassword`, { ...params })

const getCode = async (params) => await Post(`/getCode`, { ...params })
const codeVerify = async (params) => await Post(`/codeVerify`, { ...params })
const getPhoneCode = async (params) => await Post(`/getPhoneCode`, { ...params })
const getUserInfo = async (params) => await Get(`/auth/users/info`, { ...params })
const updateUserInfo = async (params) => await Post(`/auth/users/update`, { ...params })
const updatePhone = async (params) => await Post(`/auth/updatePhone`, { ...params })
const updateEmail = async (params) => await Post(`/auth/updateEmail`, { ...params })
const setLanguage = async (params) => await Post(`/auth/users/setLanguage`, { ...params })

const pay = async (params) => await Post(`/auth/payment/checkout`, { ...params })
const applyRefund = async (params) => await Post(`/auth/payment/applyRefund`, { ...params })
const cancelRefund = async (params) => await Post(`/auth/payment/cancelRefund`, { ...params })
const orderSuccessFaq = async (params) => await Post(`/orderSuccessFaq/add`, { ...params })
const applyRefundFaq = async (params) => await Post(`applyRefundFaq/add`, { ...params })
const cancerOrderFaq = async (params) => await Post(`/cancerOrderFaq/add`, { ...params })
const getPaymentInfo = async (params) => await Get(`/auth/orders/getPaymentInfo`, { ...params })
const payAtome = async (params) => await Post(`/auth/payment/checkoutByAtome`, { ...params })
const getPrice = async (params) => await Post(`/testCenters/getPrice`, { ...params })

export const API = {
  getFaqList,
  getFaqTypeList,
  getAgreementList,
  getAgreementInfo,
  getTestCenterList,
  getTestCenterPage,
  getTestCenterInfo,
  getClinicDoctorList,
  getDoctorList,
  getDoctorInfo,
  getPrice,
  getNoAppointmentTimes,
  getAllBookings,
  getOrderPage,
  getOrderInfo,
  updateOrder,
  addOrder,
  cancelOrder,
  getReportPage,
  getReportInfo,
  signIn,
  signUp,
  getBackPassword,
  getCode,
  codeVerify,
  getPhoneCode,
  changePassword,
  getUserInfo,
  updateUserInfo,
  setLanguage,
  updatePhone,
  updateEmail,
  pay,
  applyRefund,
  cancelRefund,
  getPaymentInfo,
  payAtome,
  orderSuccessFaq,
  applyRefundFaq,
  cancerOrderFaq,
  getAllTime,
  getDoctorBookings,
}
